var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('span',[_c('v-icon',[_vm._v("mdi-star")]),_vm._v(" SEO\n    ")],1)]),_c('v-divider'),_c('v-card-text',[_c('seo-description'),_c('br'),_c('seo-keywords')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }